/* eslint-disable no-useless-constructor */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'Common/Components/Dropdown';
import { UserRoleDropdownStyle } from 'Common/styles/style';
import { injectIntl } from 'react-intl';
import { Wrapper } from './styled';
import { ThemeContext } from 'Context';
import { getEESelector, getEEAction } from 'Common/ee/registry';
import { connect } from 'react-redux';
import { FEATURE_ROLES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByFeature } from 'Hooks/usePermission/selector';

const SeverityItem = ({ title }) => (
  <div className="d-inline-flex item-option role-name">
    <span>{title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()}</span>
  </div>
);

SeverityItem.propTypes = {
  title: PropTypes.string.isRequired
};

// eslint-disable-next-line react/prefer-stateless-function
class UserRoleDropdown extends React.Component {
  constructor (props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount () {
    const { getRoles, canReadCustomRoles } = this.props;
    if (canReadCustomRoles) getRoles();
  }

  onChange (value) {
    const { updateValue } = this.props;
    updateValue(value);
  }

  render () {
    const {
      defaultValue, intl, id, disabled, tooltip, themeStyles, roles
    } = this.props;
    const options = roles.map((element) => ({ value: element.value, label: <SeverityItem title={ element.name?.replace(/[-_]/g, ' ') } /> }));

    return (
      <Wrapper id={ id } title={ tooltip } disabled={ disabled }>
        <Dropdown disabled={ disabled } customStyle={ UserRoleDropdownStyle(themeStyles) } options={ options } updateValue={ this.onChange } placeholder={ `${intl.formatMessage({ id: 'user-role' })}*` } defaultValue={ defaultValue?.replace(/[-_]/g, ' ') } />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  roles: getEESelector('roles-for-dropdown', () => [])(state),
  canReadCustomRoles: selectAllowedByFeature(state, FEATURE_ROLES, PERMISSION_TYPES.READ)
});

const mapDispatchToProps = (dispatch) => ({
  getRoles: () => {
    const getRolesForDropdown = getEEAction('get-roles-for-dropdown');
    if (getRolesForDropdown) dispatch(getRolesForDropdown());
  }
});

UserRoleDropdown.propTypes = {
  updateValue: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  themeStyles: PropTypes.object.isRequired
};

UserRoleDropdown.defaultProps = {
  defaultValue: undefined,
  id: '',
  disabled: false,
  tooltip: ''
};

const ConnectedUserRoleDropdown = connect(mapStateToProps, mapDispatchToProps)(UserRoleDropdown);

const UserRoleDropdownWithTheme = (props) => {
  const { themeStyles } = useContext(ThemeContext);

  return <ConnectedUserRoleDropdown { ...props } themeStyles={ themeStyles } />;
};

export default injectIntl(UserRoleDropdownWithTheme);
